import { QueryOptions, queryOptions } from '@tanstack/react-query';
import { service } from '@maia/customer';

export type Claims = Awaited<ReturnType<(typeof service)['getClaims']>>;

export function getClaimsOptions(
  guid: string,
  search: Record<string, unknown> = {},
  initialData: QueryOptions<Claims>['initialData'] = undefined,
) {
  return queryOptions({
    queryKey: ['customers', 'claims', guid, [search]],
    queryFn: async () => await service.getClaims(guid, search),
    initialData,
  });
}
